// Real-world money figures the game uses, in FCFA. Each has the date it was
// true so the server owner can update them as prices change.
export const ECONOMY = {
  currency: 'FCFA',
  checked: '2026-10-02',
  taxiSeatDay: 350, // shared taxi, per passenger, 5 am to 10 pm (since February 2024)
  taxiSeatNight: 400,
  taxiDrop: 800, // hiring the whole taxi for a short ride (500 to 1,000)
  petrolPerLitre: 840, // state price, confirmed 28 September 2026
  dieselPerLitre: 828,
  roadsidePetrolPerLitre: 1000,
  coach: { Douala: 6000, 'Yaoundé': 8000, Buea: 6500, Limbe: 7000 },
  bread: 150,
  beer: 700,
  meal: 1500, // estimate: no published price was found for a plate of local food
  roomRentPerMonth: 40000,
  weeklyRent: 10000, // what the landlord takes every game Saturday for the player's room
  remittance: 10000, // what a bushfaller family sends home every game week
  njangiShare: 2500, // the weekly contribution to the player's njangi
  njangiMembers: 8, // one collects the pot of members x share every week in turn
  startBushfaller: 120000, // the start a bushfaller family gives
  startQuarter: 8000, // the start a quarter boy gets
  // What a player's buildings bring in each game day. Estimates: a stall let to
  // a trader, and a small house let to a family at well under the town rent.
  stallTakingsPerDay: 300,
  houseRentPerDay: 1000,
  peoplePerStall: 200, // how many townspeople it takes to keep one player's stall busy
  minimumWagePerMonth: 43969, // decree of 23 February 2024
  usedBike: 200000,
  newBike: 850000,
  usedTaxi: 3200000,
  mobileMoneyFee: 0.005, // 0.5%, capped
  mobileMoneyFeeCap: 500,
};

// What people do for a living and roughly what it brings in per month.
// Incomes are estimates anchored on the minimum wage and on a bike rider's
// reported 2,000 to 2,500 FCFA a day; most work is informal.
export const ROLES = [
  { id: 'infant', name: 'Infant', income: 0 },
  { id: 'pupil', name: 'Pupil', income: 0 },
  { id: 'student', name: 'Student', income: 0 },
  { id: 'farmer', name: 'Farmer', income: 38000 },
  { id: 'trader', name: 'Market trader', income: 55000 },
  { id: 'rider', name: 'Bike rider', income: 56000 },
  { id: 'driver', name: 'Taxi driver', income: 75000 },
  { id: 'teacher', name: 'Teacher', income: 110000 },
  { id: 'nurse', name: 'Nurse', income: 105000 },
  { id: 'civil', name: 'Civil servant', income: 150000 },
  { id: 'builder', name: 'Builder', income: 60000 },
  { id: 'tailor', name: 'Tailor', income: 50000 },
  { id: 'mechanic', name: 'Mechanic', income: 65000 },
  { id: 'hairdresser', name: 'Hairdresser', income: 45000 },
  { id: 'shopkeeper', name: 'Shopkeeper', income: 70000 },
  { id: 'herder', name: 'Cattle herder', income: 60000 },
  { id: 'tapper', name: 'Palm wine tapper', income: 42000 },
  { id: 'pastor', name: 'Pastor', income: 70000 },
  { id: 'jobless', name: 'Looking for work', income: 9000 },
  { id: 'elder', name: 'Elder', income: 12000 },
  { id: 'fon', name: 'Fon', income: 180000 },
  { id: 'mayor', name: 'Mayor', income: 300000 },
  { id: 'fisher', name: 'Fisherman', income: 52000 },
  { id: 'police', name: 'Gendarme', income: 95000 },
];
export const ROLE = Object.fromEntries(ROLES.map((r, i) => [r.id, i]));
